import { httpClient } from '#shared'
import { HTTPError } from 'ky'
import type { GetPersonalChatErrorResponse } from '../model/get-personal-chat-error-response'
import type { GetPersonalChatResponse } from '../model/get-personal-chat-response'

export async function getPersonalChat(peerId: number) {
  try {
    const response = await httpClient.get<GetPersonalChatResponse>(`chats/personal/${peerId}`, { requireAuth: true })
    const responseBody = await response.json()
    return responseBody.data
  } catch (error: unknown) {
    if (error instanceof HTTPError) {
      const responseBody = (await error.response.json()) as GetPersonalChatErrorResponse

      if (responseBody.errorSlug === 'chat_not_found') {
        return null
      }
    }

    throw error
  }
}
